import classNames from 'classnames/bind';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import { roundToDecimal } from '@/utils/Formatter';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    timeout: useRef(),
    minAlt: useRef(),
    maxAlt: useRef(),
    horizMoveLimit: useRef(),
  }).current;

  useEffect(() => {
    domRefs.timeout.current.value = command.data.timeout;
    domRefs.minAlt.current.value = command.data.minAlt.toFixed(1);
    domRefs.maxAlt.current.value = command.data.maxAlt.toFixed(1);
    domRefs.horizMoveLimit.current.value = command.data.horizMoveLimit.toFixed(1);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);

    // Timeout 변경된 경우
    if (name === 'timeout') {
      const nextValue = Math.round(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
    // Min Relative Altitude 변경된 경우
    else if (name === 'minAlt') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
    // Max Relative Altitude 변경된 경우
    else if (name === 'maxAlt') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
    // Horizontal Move Limit 변경된 경우
    else if (name === 'horizMoveLimit') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Timeout" unit="secs">
        <FieldNumber ref={domRefs.timeout} name="timeout" min={0} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Min Relative Altitude" unit="m">
        <FieldNumber ref={domRefs.minAlt} name="minAlt" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Max Relative Altitude" unit="m">
        <FieldNumber ref={domRefs.maxAlt} name="maxAlt" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Horizontal Move Limit" unit="m">
        <FieldNumber ref={domRefs.horizMoveLimit} name="horizMoveLimit" min={0} onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
